import React, { Component } from 'react';

import { Access } from 'common';
import { Page, Breadcrumbs, Navigation } from 'components';

class Main extends Component {
  state = {
    breadcrumbs: [{ name: 'Home', to: '/' }, { name: 'Benefícios', to: '' }],
    navigation: [
      { name: 'Lista de Beneficios', to: '/benefits/list', hidden: !Access.hasPermissions('manage-benefits') },
      { name: 'Tipos de Benefícios', to: '/benefits/types/list', hidden: !Access.hasPermissions('manage-benefits') },
      { name: 'Campanha Comercial', to: '/benefits/campaign/list', hidden: !Access.hasPermissions('manage-benefits') },
    ],
  };

  render() {
    const { breadcrumbs, navigation } = this.state;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Navigation items={navigation} />
      </Page>
    );
  }
}

export default Main;
